import { RequestSender } from "./helpers";

type ClassWalletSessionItemInput = {
  readonly priceLookupKey: string;
  readonly quantity: number;
};

type PopulateClassWalletSessionItemsInput = {
  readonly orderId: string;
  readonly items: ReadonlyArray<ClassWalletSessionItemInput>;
};

async function populateClassWalletSessionItemsNoStu(
  request: RequestSender,
  { orderId, items }: PopulateClassWalletSessionItemsInput,
): Promise<void> {
  const response = await request<any>(
    "put",
    `/class-wallet/order-sessions/${encodeURIComponent(orderId)}/items`,
    {
      items,
    },
  );

  if (response.status !== 204) {
    throw new Error(response.data.message);
  }
}

export type { PopulateClassWalletSessionItemsInput };
export default populateClassWalletSessionItemsNoStu;
